import axios from "../axios/AxiosInstance";

const URL = "user/me/commercial-state";
const legacyKey = () =>
  `jm-commercial-live:${localStorage.getItem("userId")}:${localStorage.getItem("agencyName")}`;

// Reprend l'état enregistré dans le navigateur par les versions précédentes, une seule fois.
function readLegacyState() {
  try {
    const saved = JSON.parse(localStorage.getItem(legacyKey()));
    return saved && typeof saved === "object" ? saved : null;
  } catch {
    return null;
  }
}

export async function loadCommercialState() {
  const { data } = await axios.get(URL);
  if (data?.state) return data.state;
  const legacy = readLegacyState();
  if (legacy) {
    await axios.put(URL, { state: legacy });
    try { localStorage.removeItem(legacyKey()); } catch { /* Stockage indisponible. */ }
  }
  return legacy;
}

let timer = null;
let pending = null;
let waiting = [];
// Regroupe les sauvegardes rapprochées ; toutes les promesses en attente suivent le dernier envoi.
export function saveCommercialState(state, delay = 1500) {
  pending = state;
  clearTimeout(timer);
  return new Promise((resolve, reject) => {
    waiting.push({ resolve, reject });
    timer = setTimeout(() => {
      const body = pending;
      const callers = waiting;
      pending = null;
      waiting = [];
      axios.put(URL, { state: body }).then(
        (result) => callers.forEach((caller) => caller.resolve(result)),
        (error) => callers.forEach((caller) => caller.reject(error)),
      );
    }, delay);
  });
}
